var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5UberpruefenActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_5-uberpruefen-active",
    "data-name": "5-uberpruefen-active",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 84.563,
    height: 84.563,
    viewBox: "0 0 84.563 84.563",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1961",
    "data-name": "Rechteck 1961",
    width: 84.563,
    height: 84.563,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_671",
    "data-name": "Gruppe 671",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4143",
    "data-name": "Pfad 4143",
    d: "M84.189,42.683A41.507,41.507,0,1,1,42.682,1.176,41.507,41.507,0,0,1,84.189,42.683",
    transform: "translate(-0.401 -0.401)",
    fill: "#00467d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4144",
    "data-name": "Pfad 4144",
    d: "M42.282,84.563A42.281,42.281,0,1,1,84.563,42.282,42.329,42.329,0,0,1,42.282,84.563m0-83.013A40.732,40.732,0,1,0,83.014,42.282,40.778,40.778,0,0,0,42.282,1.55",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_673",
    "data-name": "Gruppe 673",
    transform: "translate(40.383 -18.542) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4145",
    "data-name": "Pfad 4145",
    d: "M73.845,26.9a.611.611,0,0,0,.115.062,2.486,2.486,0,0,1,1.781,3.406Q73.8,36.186,71.862,42q-4.451,13.352-8.9,26.7a2.432,2.432,0,0,1-2.531,1.981,2.232,2.232,0,0,1-1.46-.621c-.257-.239-.5-.488-.746-.742a.651.651,0,0,1-.064-.971.658.658,0,0,1,1,.06c.19.181.371.373.559.557a1.079,1.079,0,0,0,1.915-.454q1.507-4.5,3-9.011,4.886-14.658,9.769-29.317c.113-.341.163-.7.242-1.054l-.162-.057L48.358,57.736a2.883,2.883,0,0,1,.422.291q3.975,3.964,7.941,7.937a2.229,2.229,0,0,1,.3.322.648.648,0,0,1-.918.89,2.629,2.629,0,0,1-.32-.3c-1.851-1.85-3.707-3.695-5.543-5.559a.624.624,0,0,0-.826-.153c-1.191.519-2.4,1-3.6,1.489a1.213,1.213,0,0,1-1.793-.87c-.876-3-1.742-6-2.629-8.993a1.811,1.811,0,0,0-.434-.728c-1.881-1.9-3.778-3.79-5.668-5.683a2.227,2.227,0,0,1,.744-3.877L64.1,30.646c.094-.04.185-.087.281-.122a.67.67,0,0,1,.923.325.653.653,0,0,1-.413.885c-1.367.589-2.739,1.165-4.111,1.745L36.539,43.717c-.9.38-1.027,1.036-.335,1.729q2.713,2.715,5.428,5.427c.092.092.19.176.313.289l30.76-22.607-.038-.076c-.113.039-.229.071-.339.117q-2.2.926-4.4,1.858a.7.7,0,0,1-.882-.119c-.323-.353-.166-.864.349-1.08,1.883-.789,3.771-1.567,5.656-2.35ZM45.192,61.13l.1,0c.5-1.148,1-2.3,1.513-3.44a2.539,2.539,0,0,1,.422-.655Q57,46.3,66.782,35.578q1.248-1.369,2.492-2.741a.737.737,0,0,0-.393.164q-1.361,1-2.72,2Q54.573,43.513,42.98,52.021a.539.539,0,0,0-.236.715c.33,1.059.624,2.129.934,3.193q.756,2.6,1.515,5.2m2.532-2.286-.842,1.95,1.945-.808-1.1-1.142",
    transform: "translate(-11.752 -9.179)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4146",
    "data-name": "Pfad 4146",
    d: "M51.507,91.8c-.582-.015-.892-.491-.7-.909a1.1,1.1,0,0,1,.231-.314q2.4-2.407,4.806-4.808a1.222,1.222,0,0,1,.2-.174.651.651,0,0,1,.9.917,1.254,1.254,0,0,1-.175.2q-2.388,2.389-4.78,4.772a2.564,2.564,0,0,1-.474.32",
    transform: "translate(-17.313 -29.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4147",
    "data-name": "Pfad 4147",
    d: "M33.484,69.318a.658.658,0,0,1-.659-.964,1.3,1.3,0,0,1,.221-.268q1.623-1.626,3.247-3.248a1.567,1.567,0,0,1,.126-.121.664.664,0,0,1,.911.007.615.615,0,0,1,.02.9Q35.6,67.4,33.821,69.149a1.008,1.008,0,0,1-.337.169",
    transform: "translate(-11.17 -22.018)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4148",
    "data-name": "Pfad 4148",
    d: "M39.71,85.606c-.2-.174-.479-.3-.524-.488a.955.955,0,0,1,.158-.746c.466-.541,1-1.025,1.5-1.531.455-.455.9-.915,1.364-1.364a.676.676,0,0,1,1.006-.074.658.658,0,0,1-.08,1.005q-1.417,1.434-2.855,2.848a3.205,3.205,0,0,1-.574.35",
    transform: "translate(-13.362 -27.706)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5UberpruefenActive);
export default __webpack_public_path__ + "static/media/5-uberpruefen-active.4a6e5f9d378265302c1af054b98a7be8.svg";
export { ForwardRef as ReactComponent };